import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@env/environment';

@Injectable()
export class AdminContentGroupProvider {

    constructor(private http: HttpClient) {}

    getGroups(id: number, params?: any): Observable<any> {
        return this.http.get(`${environment.envVar.API_URL}/admin/contents/${id}/groups`, {params}).pipe(
            map(data => data)
        );
    }

    getAvailableGroups(id: number, params?: any): Observable<any> {
        return this.http.get(`${environment.envVar.API_URL}/admin/contents/${id}/groups/available`, {params}).pipe(
            map(data => data)
        );
    }

    addToGroup(id: number, params: any): Observable<any> {
        return this.http.post(`${environment.envVar.API_URL}/admin/contents/${id}/groups`, params).pipe(
            map(data => data)
        );
    }

    deleteFromGroup(id: number, params?: any): Observable<any> {
        return this.http.delete(`${environment.envVar.API_URL}/admin/groups/${id}/contents`, {params}).pipe(
            map(data => data)
        );
    }
}
